const CAROUSEL_MAIN_IMAGE = '.image-carousel-container';
const CAROUSEL_THUMBNAILS = '.thumbnails';

const icons = {
  "plus": "fa-plus",
  "minus": "fa-minus",
  "caretDown": "fa-caret-down",
  "caretUp": "fa-caret-up"
}; 

function initProductImageCarousel() {
  $(CAROUSEL_MAIN_IMAGE).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.main-image_arrows--left'),
    nextArrow: $('.main-image_arrows--right'),
    arrows: false,
    fade: true,
    asNavFor: CAROUSEL_THUMBNAILS,
    responsive: [{
      breakpoint: 1025,
      settings: {
        dots: true
      }
    }]
  });
  $(CAROUSEL_THUMBNAILS).slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: CAROUSEL_MAIN_IMAGE,
    focusOnSelect: true,
    vertical: true,
    arrows: true
  });
}

function initModalImageCarousel(slideNumber) {
  $(CAROUSEL_MAIN_IMAGE).slick('setPosition');
  $(CAROUSEL_THUMBNAILS).slick('setPosition');
  $('.modal').find(CAROUSEL_MAIN_IMAGE).slick('slickSetOption', 'arrows', true, true);
  $('.modal').find(CAROUSEL_THUMBNAILS).slick('slickGoTo', slideNumber);
  $('.modal').find(CAROUSEL_MAIN_IMAGE).slick('slickGoTo', slideNumber);
}

$(document).ready(function () {
  $(CAROUSEL_MAIN_IMAGE).length > 0 && initProductImageCarousel();

  $('.r-carousel').each(function () {
    $(this).slick({
      infinite: true,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 6,
      prevArrow: $(this).closest('.r-carousel-container').find('.r-carousel_arrows--left'),
      nextArrow: $(this).closest('.r-carousel-container').find('.r-carousel_arrows--right'),
      responsive: [{
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
      ]
    });
  });

  $('.three-item-carousel').each(function () {
    $(this).slick({
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(this).closest('.three-item-carousel-container').find('.r-carousel_arrows--left'),
      nextArrow: $(this).closest('.three-item-carousel-container').find('.r-carousel_arrows--right'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  // jquery modal
  // product carousel model function
  
  // $('.product-description-container .image-carousel-container').slick("slickNext");
  $('.product-description-container .image-carousel-container').click(function() {
      $(this).slick('slickGoTo', parseInt($(this).slick('slickCurrentSlide'))+1);
  });

  $('.carousel-zoom-icon svg').click(function (e) {
    let currentSlideNumber = $('.product-description-container .image-carousel-container').slick('slickCurrentSlide');
    $('.modal').show();
    $('.modal-bg').show();
    $('.close-modal').show();
    e.preventDefault();
    $('body').addClass("modalBodyOverflow");
    $('.modal').addClass('modalOverflow');
    $('.slick-slide').addClass('modal-thumb');
    initModalImageCarousel(currentSlideNumber);
  });

  $('.close-modal').click(function (e) {
    $('.modal').hide();
    $('.modal-bg').hide();
    e.preventDefault();
    $('body').removeClass("modalBodyOverflow");
    $('.close-modal').hide();
  });

  // mobile menu

  //  hamburger toggle
  $(".hambtoggle").click(function () {
    $('.navbar__sidenav').toggleClass('active');
    $('body').toggleClass('scroll-disable');
  });

  $(".subnav-close-icon").click(function () {
    $('.navbar__sidenav').removeClass('active');
    $('body').removeClass('scroll-disable');
    $('.mobile-menu').hide();
    $('.mobile-menu').removeClass('m-submenu-opened');
    $('.sidenav__menu__item').show();
    $('.sidenav__list__one').removeClass('menu-levelone-opened');
    $('.levelone-item').removeClass('levelone-item-opened');
    $('.levelone-item').show();
    $('.mobile-submenu').hide();
  });

  $('.mobile-menu').hide();
  $('.mobile-menu').click(function() {
    $('.levelone-item').show();
    $(this).removeClass('m-submenu-opened');
    $('.levelone-item').removeClass('levelone-item-opened');
    $('.mobile-submenu').slideUp();
    $('.mobile-menu').hide();
  })

  $('.levelone-item').click( function(){
    $('.mobile-menu').show();
    $(this).find('.mobile-submenu').slideDown();
    $(this).closest('.menu-levelone').siblings('.mobile-menu').addClass('m-submenu-opened');
    $(this).addClass('levelone-item-opened');
    $(this).find('.forward-arrow').hide();
    $(this).siblings('.levelone-item').hide();
  });


  /*** search nav ***/
  
  // var currentElem;	

  // function stopScroll() {
  //     if(currentElem)
  //     {
  //         var top = $("input:focus").offset().top;
  //         $('html, body').stop().animate({
  //             scrollTop: top
  //         },0, function(){});
  //     }
  // }
  
  // function disableScrolling(elem) {
  //     currentElem = elem;
  //     document.addEventListener("touchend", stopScroll);
  //     setTimeout(function() {
  //         stopScroll();
  //     },10);
  // }
  
  // function enableScrolling() {
  //     currentElem = undefined;
  //     document.removeEventListener("touchend", stopScroll);
  // }


  // var iOS = navigator.platform && /iPad|iPhone|iPhone Simulator|iPod/.test(navigator.platform);
  
  // announcement bar
  
  $('.announcement-bar-close').click(function() {
    $('.announcement-bar').hide();
  });

  // cookie banner


  var date = new Date();
  var daysStored = 30;
  date.setTime(date.getTime() + daysStored * 24 * 60 * 60 * 1000);
  var expires = "expires=" + date.toGMTString();

  // check customer cookies 

  $('#user-register-btn').click(function() {
        document.cookie = "customer_signed_up=true;" + expires + "; Secure; path=/";
  })


  if (document.cookie.includes("existing_customer=true") || document.cookie.includes("customer_signed_up=true")) {
    $('.customer-action--link').html(`<a href="/account/login" id="customer_login_link" class="navtext">Log In</a>`);
  } else {
    $('.customer-action--link').html(`<a href="/account/register" id="customer_register_link" class="navtext">Register</a>`);
  }

  if (document.cookie.includes("registering_customer_exist=true") || document.cookie.includes("customer_signed_up=true")) {
    $('#user_auth_regi_title').text(`welcome back`);
  }
  
  // general-content Item tabs

  $('.general-content-items ul li a').click(function () {
    let tab_id = $(this).attr('data-tab');
    $('.general-content-items ul li a').removeClass('current');
    $('.item-content').removeClass('current');

  $(this).addClass('current');
  $("#" + tab_id).addClass('current');
  });

  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        $('.designer-list-filter').removeClass('toggler');
        $('body').removeClass('active');
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        var listingFiltersHeight = 25; 
        if($('.designer-list-filter').css('display') == 'block') {
           listingFiltersHeight = 216; // desktop designer-listing filters height
        }
        var mobileDesignerFilterHeight = 111; // mobile filter btn height
        var headerHeight = ($(".navbar").height() > 60 ) ? $(".navbar").height() + listingFiltersHeight : $(".navbar").height() + mobileDesignerFilterHeight; 
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - headerHeight
          }, 1000);
        }
      }
    });
  // open all items accordion


  var jump = function(e) {
    if (e) {
        e.preventDefault();
        var target = $(this).attr("href");
    } else {
        var target = location.hash;
    }
    var headerHeight = $(".navbar").height() + 180;
    $('html,body').animate({
     scrollTop: $(target).offset().top - headerHeight
    },0,function() {
        location.hash = target;
    });
  }
    if (location.hash && location.hash != '#ContactFooter' && location.hash != '#newsletter-popup'){
        setTimeout(function(){
            jump();
            window.history.pushState("","","/pages/shop-by-designer");
        }, 0);
    }

    $('a.navigator_link').on("click", jump);
  

  // accordions on product details page end



  var filterAccordion = $('.accordion-item');
  var filterAccordionItems = $('.accordion__panel');

  $(document).click(e => {
    if (!filterAccordion.is(e.target) // if the target of the click isn't the container...
      && filterAccordionItems.has(e.target).length === 0) // ... nor a descendant of the container
    {
      filterAccordionItems.removeClass('make-element-block');
      $('.accordion-item').find('.filter-arrow-down').removeClass('rotate-accordion-icon');
    }
  });

  $(filterAccordion).on('click', () => {
    filterAccordionItems.toggleClass('make-element-block');
    $('.accordion-item').find('.filter-arrow-down').toggleClass('rotate-accordion-icon');
    $('.accordion-item').toggleClass('filter-arrow-active');
  });

  var acc = $(".panel__list__item");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        $(panel).hide();
      } else {
        $(panel).show();
      }
    });
  }


  // quantity picker
  $('.quantityAdd').click(function () {
    var findCount = $(this).closest('.wrap').find('.count');
    if (findCount.val()<100) findCount.val(+findCount.val() + 1);
  });
  $('.quantitySubtract').click(function () {
    var findCount = $(this).closest('.wrap').find('.count');
    if(findCount.val() > 1) { 
      findCount.val(+findCount.val() - 1);
    }
  });

  $('.select-selected').click(function() {
    if($(this).hasClass('.select-arrow-active')) {
      $(this).css('color', '#8e8b8b')
    };
  });


  // selectable dropdown
  var x, i, j, selElmnt, a, b, c;
  /*look for any elements with the class "custom-select":*/
  x = document.getElementsByClassName("custom-select");
  for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < selElmnt.length; j++) {
      /*for each option in the original select element,
      create a new DIV that will act as an option item:*/
      d = document.createElement("div");
      d.setAttribute("class", "block");
      d.classList.add('variant--sold-out');
      c = document.createElement("span");
      c.innerHTML = selElmnt.options[j].innerHTML;
      d.appendChild(c);

      d.addEventListener("click", function (e) {
        /*when an item is clicked, update the original select box,
        and the selected item:*/
        let selectedDivElement = this;
        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        h = this.parentNode.previousSibling;
        let actualSelectElement = $(selectedDivElement).closest('.size').find('.product-form__variants');
        actualSelectElement.children().removeAttr('selected');
        actualSelectElement.children().each(function(_index, option) {
          if(selectedDivElement.firstChild.innerHTML == $(option).data('value')){
            $(option).prop('selected', 'true');
            $('#product-form__item--btn').removeAttr('disabled');
            if($('#product-form__item--btn span[data-add-to-cart-text').attr('data-pre-order') === "true") {
              $('#product-form__item--btn span[data-add-to-cart-text').text('PRE-ORDER');
            }
            else {
              $('#product-form__item--btn span[data-add-to-cart-text').text('add to bag');
            }
            $(option).parent().val($(option).attr('value'));
            $('.klaviyo-bis-trigger').removeClass('active');

            // To update price
            var selectedVariantId = $(option).prop('value');
            var productJSON = JSON.parse($('#ProductJson-product-template').first().html());
            var selectedVariant = productJSON.variants.find(function(variant) {
              console.log(variant.id, selectedVariantId);
              return parseInt(variant.id) === parseInt(selectedVariantId);
            });
            console.log(selectedVariant, selectedVariant.price);
            var selectedVariantPrice = theme.Currency.formatMoney(
              selectedVariant.price,
              theme.moneyFormatWithCurrency
            );

            $('.product__description--price [data-regular-price]').html(selectedVariantPrice);
          }   
        });
        for (i = 0; i < s.length; i++) {
          if (s.options[i].value == this.firstChild.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            console.log(h)
            y = this.parentNode.getElementsByClassName("same-as-selected");
            for (k = 0; k < y.length; k++) {
              y[k].classList.remove("same-as-selected");
            }
            this.classList.add("same-as-selected");
            break;
          }
        }
        h.click();
      });
      b.appendChild(d);
    }
    x[i].appendChild(b);
    var selectedElm = $('.select-selected');
    a.addEventListener("click", function (e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      $(this).closest('.custom-select').siblings('.dropdown-arrow').toggleClass('rotate-accordion-icon');
      e.stopPropagation();
      closeAllSelect(this);
      selectedElm.next().toggleClass("select-hide");
      selectedElm.toggleClass("select-arrow-active");
      if (selectedElm.next().children('div').hasClass('same-as-selected')) {
        selectedElm.css('color', '#282525');
      } else {
        selectedElm.css('color', '#282525');
      }
    });
  }

  $('.select-items div').each(function() {
    let optionText = $(this).find('span').text();
    let ProductVariants = $('.product-form__variants option');
    for(i=0; i < ProductVariants.length; i++) {
      if(optionText === $(ProductVariants[i]).attr('data-value')) {
        $(this).removeClass('variant--sold-out');
      }
    }
  })

  $('.product-form-product-template-multiple-options .variant--sold-out').removeClass('variant--sold-out');

  $('.variant--sold-out').each(function(){
    let wishlistText = $('<span class="wishlist-text"> - Add to Waitlist</span>');
    $(this).find("span:first-child").addClass('sold-out-item-text');
    $(this).addClass('klaviyo-bis-trigger');
    $(this).append(wishlistText);
  })

  $('.variant--sold-out').on('click', function() {
    $('#product-form__item--btn span[data-add-to-cart-text').text('sold out');
    $('#product-form__item--btn').attr('disabled','disabled');
    $('.klaviyo-bis-trigger').addClass('active');
  });
  

  function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/

    // $('.custom-select').siblings('.dropdown-arrow').removeClass('rotate-accordion-icon');
    var x, y, i, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    for (i = 0; i < y.length; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i)
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < x.length; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }
  

  /*if the user clicks anywhere outside the select box,
  then close all select boxes:*/
  document.addEventListener("click", function() {
    closeAllSelect();
    $('.custom-select').siblings('.dropdown-arrow').removeClass('rotate-accordion-icon');
  });

  // selectable dropdown end

 // tabs

  $('.tabs .editorial-tab').click(function () {
    var tab_id = $(this).attr('data-tab');

    $('.editorial-tab').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#" + tab_id).addClass('current');
    $('.default__editorial__articles').hide();
    $('.editorial').hide();
  });


  // window.onscroll = function () {
  //   makeHeaderSticky();
  //   subMenuSticky();
  //   makeListingFiltersSticky();
  // };

  function makeHeaderSticky() {
    let header = $('#shopify-section-header')[0];
    let headerOffset = 0;
    if (window.pageYOffset > headerOffset) {
      header.classList.add("collapsed");
    } else {
      header.classList.remove("collapsed");
    }
    if($('.brand-drawer-opened').hasClass("collapsed")) {
      $('.designer-list-filter').removeClass('listing-filters-position');
    } else {
      $('.designer-list-filter').addClass('listing-filters-position');
    }
    let DrawerOpen = $('.header--sticky').hasClass('brand-drawer-opened');
    if(!DrawerOpen) {
      $('.designer-list-filter').removeClass('listing-filters-position');
    } 
  }

  // brand statement

  $('.brand-drawer-toggler').click(function(){
    $('.brand-drawer').toggleClass('drawer-slider');
    $('.header--sticky').toggleClass('brand-drawer-opened');
    $('.submenu').toggleClass('submenudrawer');
    $('.designer-list-filter').toggleClass('listing-filters-position')
  });
  

  function subMenuSticky() {
    let subMenu = $('.submenu');
    let subMenuOffset = 0;
    if (window.pageYOffset > subMenuOffset) {
      subMenu.addClass("submenu-collapsed");
    } else {
      subMenu.removeClass("submenu-collapsed");
    }
  }

  // designer-listing page

  // for toggling the designer listig filter
  $('.designer-filter-toggler').click(function () {
    $('.designer-list-filter').toggleClass('toggler');
    $('body').toggleClass('active');
  });
    // end toggling the designer listig filter

    function makeListingFiltersSticky() {
      let listingFilters = $('.designer-list-filter');
      let filterbtnSticky = $('.mobile-designer-filter');
      // var collectionFilters = $('.collection-page__products__mobile-filters');
      var designer_collection_filters = $('.designer__collection__header');
      var designer_banner_height = ($('.hero-banner').height() + 30);
      let headerOffset = 0;
      if (window.pageYOffset > headerOffset) {
        listingFilters.addClass("designer-list-filter-collapsed");
        filterbtnSticky.addClass('filter-collapsed');
      } else {
        listingFilters.removeClass("designer-list-filter-collapsed");
        filterbtnSticky.removeClass('filter-collapsed');
      }
      // if (window.pageYOffset > 140) {
      //   collectionFilters.addClass('filter-collapsed');
      // } else {
      //   collectionFilters.removeClass('filter-collapsed');
      // }
      if (window.pageYOffset > designer_banner_height) {
        designer_collection_filters.addClass('filter-collapsed');
      } else {
        designer_collection_filters.removeClass('filter-collapsed');
      }
    }

    // user auth
    $('#RecoverPassword').click(function(){
      $('.default-signin').hide();
      $('.forgot-pass__content').show();
      $('#ResetSuccess').hide()
    });

    $('#HideRecoverPasswordLink').click(function(){
      $('.default-signin').show();
      $('.forgot-pass__content').hide();
    })



  // for replacing hyphen with space 
  $('.accordion__panel__list').each(function(){
    const labelElm = $('ul .label-text');
    for (elm = 0; elm < labelElm.length; elm++) {
    var countryInputValue = $(labelElm[elm]).text().trim().replace(/-/g, " ");
    $(labelElm[elm]).text(countryInputValue);
    }
  });


  $('.three-columns-tile').each(function(){
    var countryElm = $('.category_tag .country-name');
    for (elm = 0; elm < countryElm.length; elm++) {
    var countryValue = $(countryElm[elm]).text().trim().replace(/-/g, " ");
    $(countryElm[elm]).text(countryValue);
    }
  });
  // end replacing hyphen with space

  // for designer listing filters 

  // cta btns
  function ctaStates(ctaBtnSelector) {
    if(ctaBtnSelector) {
      $('#designerListClear').removeClass('button--disabled');
      $('#designerListApply').removeClass('button--disabled');
      } else {
        $('#designerListClear').addClass('button--disabled');
        $('#designerListApply').addClass('button--disabled');
      }
  }

  function filterDesigners() {
    var designerLetter = $('.designer-listing-content .designers-letter');
    var designerTiles = $('.designer-listing-content .three-columns-tile');
    var sections = $('.designer-listing-content');
    var sustainableFilterApplied = $("input[name='sustainable']:checked").length > 0;

    var selectedCountries = $("input[name='country']:checked").map(function() {
      return $(this).val().toLowerCase();
    }).toArray();

    ctaStates(selectedCountries.length > 0);
    

    if(selectedCountries.length === 0 && !sustainableFilterApplied) {
      designerTiles.show();
      sections.show();
      return;
    }

    // clear all btn
    $("#designerListClear").click(function(e){
        e.preventDefault();
        $(".listing-filters label input").prop("checked", false);
        $('.clear-all--btn a').addClass('button--disabled');
        designerTiles.show();
        sections.show();
    });

    // apply btn
    $('#designerListApply').click(function(){
      $('.designer-list-filter').removeClass('toggler');
      $('body').removeClass('active');
    });

    // hide tiles which for which country is not selected
    designerTiles.each(function() {
      var country = $(this).find('.flag-sprites').data('country');
      country = country ? country.toLowerCase() : "";

      if(selectedCountries.includes(country)) {
        $(this).show();
        $(this).addClass('shown');
        $(this).addClass('country-selected');
      }
      else {
        $(this).hide();
        $(this).removeClass('shown');
        $(this).removeClass('country-selected');
      }
    });

    if(sustainableFilterApplied) {
      designerTiles.each(function() {
        var isSustainable = $(this).find('.sustainable-designer').length > 0;

        ctaStates(isSustainable);

        if(selectedCountries.length > 0) {
          if(isSustainable && $(this).hasClass('country-selected')) {
            $(this).show();
            $(this).addClass('shown');
          }
          else {
            $(this).hide();
            $(this).removeClass('shown');
          }
        }

        else {
          if(isSustainable) {
            $(this).show();
            $(this).addClass('shown');
          }
          else {
            $(this).hide();
            $(this).removeClass('shown');
          }
        }
      });
    }

    // hide sections for which country is not selected
    sections.each(function() {
      var visibleTiles = $(this).find('.shown').length;
      if(visibleTiles === 0) {
        $(this).hide();
      }
      else {
        $(this).show();
      }
    });
  }

  $('.dropdown-filter .accordion__panel__list label').click(filterDesigners);
  $('.sustainable__checkbox label').click(filterDesigners);
  
  // end designer listing filters 

  // for redering the alphabets with rendered designer-listing-tile 
  $('.designer-listing-container').each(function () {
    var designerListElm = $('.designer-listing-content');
    for (elm = 0; elm < designerListElm.length; elm++) {
      var vendor_first_alphabet = $(designerListElm[elm]).find('.three-columns-tile__text h4').text().trim().replace(/ \s/g, "");
      if (vendor_first_alphabet.length > 0) {
        $(designerListElm[elm]).find('.designers-letter').show();
      }
    }
  });


  $('.navigator_links').hover(function () {
    $(this).siblings('.navigator_links').addClass('make-hoverable');
  }, function () {
    $(this).siblings('.navigator_links').removeClass('make-hoverable');
  });

  $('.disabled-link').removeAttr('href');


  // designer-listing search
  $('.search-close').click(function() {
    $('#designerListingSearch').val('');
    $('.dropdown-filter .label-text').closest('li').show();
    $('.search-close').hide();
  })
  $(document).on('input','#designerListingSearch', function(e){
    var searchTerm = e.target.value.toLowerCase();
    var countries = $('.dropdown-filter .label-text');
    countries.each(function(_index, country){
      var countryName = $(country).text();
      if(countryName.toLowerCase().includes(searchTerm)){
        $(country).closest('li').show();
        if(searchTerm.length > 0){
          $('.search-close').show();
        } else {
          $('.search-close').hide();
        }
      }
      else {
        $(country).closest('li').hide();
      }
    });
  });

    // end designer-listing search

    // filters position

  //end designer listing page


  // form validations

  if($("input[type='email']").hasClass('input--error')) {
    $(this).parent().siblings('.input--error-icon').show();
  }

  function inputFieldValidator(inputFieldId, maxLength) {
    let errorIcon = $(inputFieldId).closest('.input-block').children('.input--error-icon');
    var errorMessageElm = $(inputFieldId).next('.client-errors-msg'); 
    if($(inputFieldId).val().length <= maxLength  || $(inputFieldId).val() == "") {
      errorMessageElm.show();
      errorIcon.show();
      
      $(inputFieldId).css({
        "border": "1px solid #A54129"
      });
      return false;
    } else {
      errorMessageElm.hide();
      errorIcon.hide();
      $(inputFieldId).css({
        "border-top": "unset",
        "border-left": "unset",
        "border-right": "unset", 
        "border-bottom": "1px solid rgba(40, 37, 37, 0.2)"
      });
    }
  }


  function confirmPasswordInputValidator(inputFieldId, maxLength) {
    let errorIcon = $(inputFieldId).closest('.input-block').children('.input--error-icon');
    var errorMessageElm = $(inputFieldId).next('.client-errors-msg'); 
    let passwordValue = $('#CustomerPassword').val();
    if($(inputFieldId).val() != passwordValue || $(inputFieldId).val().length <= maxLength) {
      errorMessageElm.show();
      errorIcon.show();
      $('.user-activation-cta').attr('disabled', 'disabled')
      $(inputFieldId).css({
        "border": "1px solid #A54129"
      });
      return false;
    } else {
      errorMessageElm.hide();
      errorIcon.hide();
      $('.user-activation-cta').removeAttr('disabled')
      $(inputFieldId).css({
        "border-top": "unset",
        "border-left": "unset",
        "border-right": "unset", 
        "border-bottom": "1px solid rgba(40, 37, 37, 0.2)"
      });
    }
  }

  function emailInputValidator(inputFieldId, emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/) {

    let errorIcon = $(inputFieldId).closest('.input-block').children('.input--error-icon');
    var errorMessageElm = $(inputFieldId).next('.client-errors-msg'); 
    $('.reg-errors-msg').hide();
    if(!(emailRegex).test($(inputFieldId).val())) {
      errorMessageElm.show();
      errorIcon.show();
      $(inputFieldId).css({
        "border": "1px solid #A54129"
      });
      return false;
    } else {
      errorMessageElm.hide();
      errorIcon.hide();
      $(inputFieldId).css({
        "border-top": "unset",
        "border-left": "unset",
        "border-right": "unset", 
        "border-bottom": "1px solid rgba(40, 37, 37, 0.2)"
      });
    }
  }

  function emailFocusout(inputFieldId) {
    var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
    var errorMessageElm = $(inputFieldId).next('.client-errors-msg').find('span');
    $('.reg-errors-msg').hide();
    if(inputFieldId.val().length < 5 && !(emailRegex).test($(inputFieldId).val()) ) {
      errorMessageElm.text(`Please enter valid Email address`);
    }
  }

  function inputFocusout(inputFieldId) {
    var inputLabel = $(inputFieldId).prev('label').text();
    var errorMessageElm = $(inputFieldId).next('.client-errors-msg').find('span');
    if(inputFieldId.val().length == "") {
      errorMessageElm.text(`${inputLabel} can't be blank`);
    }
  }


  function confirmPasswordFocusout(inputFieldId) {
    var inputLabel = $(inputFieldId).prev('label').text();
    var errorMessageElm = $(inputFieldId).next('.client-errors-msg').find('span');
    if(inputFieldId.val().length == "") {
      errorMessageElm.text(`${inputLabel} can't be blank`);
    }
  }

  function inputErrorMessages(inputFieldId, maxLength) {
    var inputLabel = $(inputFieldId).prev('label').text();
    var errorMessageElm = $(inputFieldId).next('.client-errors-msg').find('span');
    var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
    if($(inputFieldId).val() == "") {
      errorMessageElm.text(`${inputLabel} can't be blank`);
    } else if ($(inputFieldId).val().length <= maxLength) {
      errorMessageElm.text(`${inputLabel} must contains more than ${maxLength} characters`);
    } else if(!$(inputFieldId).val().includes('@')) {
      errorMessageElm.text(`${inputLabel} address must contain '@' symbol`);
    } else if(!(emailRegex).test($(inputFieldId).val())) {
      errorMessageElm.text(`Please check your Email address`);
    }
  }

  function confirmPasswordErrorMessages(inputFieldId, maxLength) {
    var inputLabel = $(inputFieldId).prev('label').text();
    var errorMessageElm = $(inputFieldId).next('.client-errors-msg').find('span');
    if($(inputFieldId).val() == "") {
      errorMessageElm.text(`password can't be blank`);
    } else if ($(inputFieldId).val().length <= maxLength) {
      errorMessageElm.text(`Please enter the correct password`);
    }
  }

  // login form
    // email
    $('#CustomerEmail').on("input", function () {
      inputFieldValidator($(this));
      emailInputValidator($(this));
      inputErrorMessages($(this), 5);
    });
    $('#CustomerEmail').on("focusout", function () {
      emailInputValidator($(this));
      emailFocusout($(this));
      inputFocusout($(this));
    });

    // recover email
    $('#RecoverEmail').on("input", function () {
      inputFieldValidator($(this));
      emailInputValidator($(this));
      inputErrorMessages($(this), 5);
    });
  
    $('#RecoverEmail').on("focusout", function () {
      emailInputValidator($(this));
      emailFocusout($(this));
      inputFocusout($(this));
    });

    // password
    $('#CustomerPassword').on("input", function () {
      inputFieldValidator($(this), 4);
      inputErrorMessages($(this), 4);
    });
  
    $('#CustomerPassword').on('focusout', function() {
      inputFieldValidator($(this), 4);
      inputFocusout($(this));
    });

    $('#CustomerPasswordConfirmation').on("input", function () {
      confirmPasswordInputValidator($(this), 4);
      confirmPasswordErrorMessages($(this), 4);
    });

    $('#CustomerPasswordConfirmation').on('focusout', function() {
      confirmPasswordInputValidator($(this), 4);
      confirmPasswordFocusout($(this));
    });

  // signup

  var registerFormInputs = function () {
    let emailInput = $('#RegisterForm-email');
    let eventbtn = $('#user-register-btn');
    let inputValue = $(emailInput).val();
    let emailValidator = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
    let emailvalidated = (emailValidator).test(inputValue);
    let passInput = $("#RegisterForm-password");
    let passinputValue = $(passInput).val();
    let userFirstName = $("#RegisterForm-FirstName").val();
    let userLastName = $("#RegisterForm-LastName").val();
    if (userFirstName.length > 1 && userLastName.length > 1 && emailvalidated && passinputValue.length > 4) {
      $('#user-register-btn').removeClass('button--disabled');
      $(eventbtn).removeAttr("disabled");
      $(emailInput).removeClass('input--error-icon');
      $(emailInput).next('.reg-errors-msg').hide();
    } else {
      $(eventbtn).addClass('button--disabled');
      $(eventbtn).attr("disabled", true);
      $(emailInput).next('.reg-errors-msg').show();
    }
    if ($(emailInput).next('.reg-errors-msg').css("display") == "block" && inputValue == "") {
      $(emailInput).addClass('input--error-icon');
    }
  }

  $('#user-register-btn').attr("disabled", true);
  // firstname

  $('#RegisterForm-FirstName').on("input", function () {
    registerFormInputs();
    inputFieldValidator($(this), 1);
    inputErrorMessages($(this), 1);
  });

  $('#RegisterForm-FirstName').on('focusout', function() {
    inputFieldValidator($(this), 1);
    inputFocusout($(this));
  });


  // lastname
  $('#RegisterForm-LastName').on("input", function () {
    registerFormInputs();
    inputFieldValidator($(this), 1);
    inputErrorMessages($(this), 1);
  });

  $('#RegisterForm-LastName').on('focusout', function() {
    inputFieldValidator($(this), 1);
    inputFocusout($(this));
  });

  // email
  $('#RegisterForm-email').on("input", function () {
    registerFormInputs();
    inputFieldValidator($(this));
    emailInputValidator($(this));
    inputErrorMessages($(this), 5);

  });


  $('#RegisterForm-email').on("focusout", function () {
    emailInputValidator($(this));
    emailFocusout($(this));
    inputFocusout($(this));
  });


  // password
  $('#RegisterForm-password').on("input", function () {
    registerFormInputs();
    inputFieldValidator($(this), 4);
    inputErrorMessages($(this), 4);
  });

  $('#RegisterForm-password').on('focusout', function() {
    inputFieldValidator($(this), 4);
    inputFocusout($(this));
  });

  //  for othe email inputs

  var emailInputs = function (inputId, btnID) {
    let emailInput = $('#' + inputId);
    let inputValue = $(emailInput).val();
    let emailValidator = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
    let emailvalidated = (emailValidator).test(inputValue);
    if (emailvalidated) {
      $(btnID).removeClass('button--disabled');
      $(btnID).removeAttr("disabled");
      $(emailInput).removeClass('input--error-icon');
      $(emailInput).next('.reg-errors-msg').hide();
    } else {
      $(btnID).addClass('button--disabled');
      $(btnID).attr("disabled", true);
      $(emailInput).next('.reg-errors-msg').show();
    }
    if ($(emailInput).next('.reg-errors-msg').css("display") == "block" && inputValue == "") {
      $(emailInput).addClass('input--error-icon');
    }
  }

  // footer subscribe button

  $("#Subscribe").attr("disabled", true);
  $('#ContactFooter-email').on('input', function () {
    emailInputs('ContactFooter-email', '.button--default');
  });

  if(location.hash == '#ContactFooter') {
    $('html, body').animate({
      scrollTop: 0
    }, 1000);
  }

  // Newsletter Popup Subscription

  $('#newsletter-popup-email').on('input', function () {
    emailInputs('newsletter-popup-email', '#newsletter-popup #Subscribe');
  });

  $('#newsletter-popup').submit( function(){
    $('p.error, p.success').remove();
    if($(this).find('input[type="email"]').val() !== ''){
      var data = $(this).serialize();
      $.ajax({  
        type: "POST",  
        url: "/contact",  
        data: data,  
        success: function() { 
          $('.contact-form').append('<p class="success">Thanks for signing up!</p>');
        },
        error: function() {
          $('.contact-form').append('<p class="error">There was an error in submitting the form.</p>');
        }    
      }); 
    }
    else {
      $(this).append('<p class="error">Please fill in your email address.</p>');  
    }
    return false;
  });

  // Popup
  newsletterCookie.closeIdentifier = "newsletterPopUpClosed";
  newsletterCookie.subscriptionIdentifier = "newsletterSubscribed";

  if(document.cookie.includes(newsletterCookie.identifier)) {
    
  }
  else {
    newsletterCookie.presentDate = new Date();
    newsletterCookie.daysStored = 30;
    newsletterCookie.expirationDate = newsletterCookie.presentDate.setTime(newsletterCookie.presentDate.getTime() + (newsletterCookie.daysStored * 24 * 60 * 60 * 1000));
    newsletterCookie.expirationDate = "expires=" + new Date(newsletterCookie.expirationDate).toUTCString();
  }

  $(document).on('click', function(e) {
    if($(e.target).closest('.popup-content').length === 0 || $(e.target).closest('.popup-close').length > 0) {
      $('.popup-container').hide();
      document.cookie = newsletterCookie.closeIdentifier + "=true;" + newsletterCookie.expirationDate + "; Secure; path=/";
    }
  });

  window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == 'submit') {
      document.cookie = newsletterCookie.subscriptionIdentifier + "=true;" + newsletterCookie.expirationDate + "; Secure; path=/";
    }
  });


  // RecoverEmail 
  $('#forgot-pass-btn').attr("disabled", true);
  $('#RecoverEmail').on('input', function () {
    emailInputs('RecoverEmail', '.email--input');
  });

  // captcha
  let challenge__message = $(`<div class="challenge__message">
                                <h4 class="text-xl">Verification<h4>
                                <p class="text-medium">Human? Let us know.</p>
                              </div>`);
  
  $('.shopify-challenge__container').prepend(challenge__message);


  // checkout page
  $(document).on('click', '.quantity-dropdown', function() {
    $(this).next('.cart-qty-numbers').slideToggle();
    $(this).find('.dropdown-arrow').toggleClass('rotate-accordion-icon');
    $('.cart-qty-numbers li span').each(function() {
    if($(this).text() == $('.cart__qty-input').val()) {
      $(this).addClass('qty-selected');
    }
    })
  });

  $(document).on('click', '.cart-qty-numbers li', function(e) {
    var qty_selected = parseInt($(this).text());

    $(this).closest('.cart__qty').find('.cart__qty-input').val(qty_selected);
    $(this).find('span').addClass('qty-selected');
    $(this).closest('li').siblings('li').find('span').removeClass('qty-selected');
    $(this).closest('.cart-qty-numbers').slideUp();
    $(this).closest('.cart-qty-numbers').siblings('.quantity-dropdown').find('.dropdown-arrow').removeClass('rotate-accordion-icon');
    $(this).closest('.cart__qty').find('.cart__qty-input').trigger('change');
  });



  // price slider

  if($('.price-slider').length > 0) {
    const sliderMultiplier = 200;
    var deskMinValue = document.getElementById("deskMinRange");
    var deskMinValueOutput = document.getElementById("deskMinRangeInput");
    deskMinValueOutput.value = '$' + deskMinValue.value * sliderMultiplier;

    var mobMinValue = document.getElementById("mobMinRange");
    var mobMinValueOutput = document.getElementById("mobMinRangeInput");
    mobMinValueOutput.value = '$' + mobMinValue.value * sliderMultiplier;

    function initMinSlider() {
      this.value = Math.min(this.value,this.parentNode.childNodes[5].value - 1);
      var value = (100 / (parseInt(this.max) - parseInt(this.min))) * parseInt(this.value) - (100 / (parseInt(this.max) - parseInt(this.min))) * parseInt(this.min);
      var children = this.parentNode.childNodes[1].childNodes;
      children[1].style.width = value + '%';
      children[5].style.left = value + '%';
      children[7].style.left = value + '%';
      children[11].style.left = value + '%';
      children[11].childNodes[1].innerHTML=this.value;
      deskMinValueOutput.value = '$ ' + parseInt(this.value * sliderMultiplier);
      mobMinValueOutput.value = '$ ' + parseInt(this.value * sliderMultiplier);
    }
    
    deskMinValue.oninput = function() {
      (initMinSlider.bind(this))();
    }
  
    mobMinValue.oninput = function() {
      (initMinSlider.bind(this))();
    }
    

    var deskMaxValue = document.getElementById("deskMaxRange");
    var deskMaxValueOutput = document.getElementById("deskMaxRangeInput");
    deskMaxValueOutput.value = '$' + deskMaxValue.value * sliderMultiplier;
  
    var mobMaxValue = document.getElementById("mobMaxRange");
    var mobMaxValueOutput = document.getElementById("mobMaxRangeInput");
    mobMaxValueOutput.value = '$' + mobMaxValue.value * sliderMultiplier;

    function initMaxSlider() {
      this.value = Math.max(this.value, this.parentNode.childNodes[3].value - (-1));
      var value=(100 / (parseInt(this.max)-parseInt(this.min))) * parseInt(this.value) - (100 / (parseInt(this.max) - parseInt(this.min))) * parseInt(this.min);
      var children = this.parentNode.childNodes[1].childNodes;
      children[3].style.width = (100-value) + '%';
      children[5].style.right = (100-value) + '%';
      children[9].style.left = value + '%';
      children[13].style.left = value + '%';
      children[13].childNodes[1].innerHTML=this.value;
      deskMaxValueOutput.value = '$ ' + parseInt(this.value * sliderMultiplier);
      mobMaxValueOutput.value = '$ ' + parseInt(this.value * sliderMultiplier);
    }

    deskMaxValue.oninput = function() {
      (initMaxSlider.bind(this))();
    }

    mobMaxValue.oninput = function() {
      (initMaxSlider.bind(this))();
    }
  }

  $('.navtwo__menu > .navtwo--menuitem > a').each(function(_i, element) {
    if(element.href === window.location.href) {
      $(element).addClass('current-page');
    }
  });


  $('.fixed-section .tile .tile__img').each( function() {
    var productGallery = []
    const product_gallery_image = $(this).find('div').attr('data-pf-type', 'ProductImageList').find('img');
    for (elm = 0; elm < product_gallery_image.length; elm++) {
      productGallery.push($(product_gallery_image[elm]).attr('src')); 
    }

    $(this).hover(function () {
      $(this).find('div').attr('data-pf-type', 'MasterImage').find('img').attr('src', productGallery[2]);
    }, function () {
      $(this).find('img').attr('src', productGallery[0]);
    });
  });

  $('.blog-module-products .tile .tile__img').each( function change_img_on_hover () {
    var productGallery = []
    const product_gallery_image = $(this).find('div').attr('data-pf-type', 'ProductGallery').find('img');
    for (elm = 0; elm < product_gallery_image.length; elm++) {
      productGallery.push($(product_gallery_image[elm]).attr('src')); 
    }
    console.log(productGallery[2]);
    $(this).hover(function () {
      $(this).find('picture img').attr('src', productGallery[2]);
    }, function () {
      $(this).find('picture img').attr('src', productGallery[0]);
    });
  });

  // size guide code

  var sizeGuideModal = $('.size-guide-modal-bg');
  var size_guide_modal = function() {
    sizeGuideModal.addClass('active');
    bodyScrollLock.disableBodyScroll(sizeGuideModal);
  }

  $('#size__guide-1').click(size_guide_modal);
  $('#size__guide-2').click(size_guide_modal);
  $('#size__guide-3').click(size_guide_modal);

  $('.size-guide-close-modal').click(function () {
    sizeGuideModal.removeClass('active');
    bodyScrollLock.clearAllBodyScrollLocks();
  });

  if($('.designer-collection-size__guide').css('display') == 'block') {
    $('.product-type-size__guide').next('.size-guide-modal-bg').remove();
    $('.product-type-size__guide').remove();
    $('.clothing-size__guide').next('.size-guide-modal-bg').remove();
    $('.clothing-size__guide').remove();
  }

  if($('.product-type-size__guide').css('display') == 'block') {
    $('.clothing-size__guide').next('.size-guide-modal-bg').remove();
    $('.clothing-size__guide').remove();
  }

  // password page

  if(window.location.pathname == "/password") {
    $('.template-password #Password').focus();
    if($('.template-password #Password').val().length > 0) {
      $('#store_password_btn').removeAttr('disabled');
    }
  }

  $('.template-password #Password').on('input', function(){
    if($(this).val().length > 0) {
      $('#store_password_btn').removeAttr('disabled')
    } else {
      $('#store_password_btn').attr('disabled','disabled')
    }
  })

  // myaccount page
  $(document).on('click', '#AddressNewButton', function() {
    $(this).hide();
    $('.customer-address-list').hide();
    $('.customer-addresses__left--text h4').text('add new address');
    $('html, body').animate({
      scrollTop: 1
    }, 1000);
  })

  $(document).on('click', '#addressesNewCancel', function() {
    $('#AddressNewButton').show();
    $('.customer-address-list').show();
    $('.customer-addresses__left--text h4').text('your addresses');
    $('html, body').animate({
      scrollTop: 1
    }, 1000);
  })

  $(document).on('click', '.cta--cancel', function() {
    $('html, body').animate({
      scrollTop: 1
    }, 1000);
  })

  // ***** Anchor link ***** //

  let newsletterSignupSelector = '#ContactFooter-email';
  let newsletterSignupInput = $('#ContactFooter-email');

  $(document).on('click', 'a[href="' + newsletterSignupSelector + '"]', function (event) {
    event.preventDefault();
    console.log("CLICKED");

    $('html, body').animate({
        scrollTop: ($(newsletterSignupInput).offset().top - 50),
      }, 400, 'linear', function() {
        console.log("COMPLETED BEFORE TO");
        setTimeout(function(){
          console.log("COMPLETED");
          newsletterSignupInput.focus();
          newsletterSignupInput.closest('.input-group').addClass('input-group--focused');
        }, 10);
      });
  });
});

$(document).on('input', '.ui-autocomplete-input', function(){
  $('#acp_footer_all b').text($(this).val())
})


  $(document).ready(function ($) {
    if($('.select-selected').text().trim() == "Choose Size") {
      $('#product-form__item--btn').attr('disabled', 'true');
    }
  });

// scrollable section end



/* ===== Sort by Dropdown ===== */

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

let filterValue = getParameterByName('sort_by', `${window.location.href}`);
$('#sorting_drop_list li').each(function(){
  if($(this).find('a').attr('sort_value') == filterValue) {
    $(this).siblings('li').find('a').removeClass('selected_sorting_value');
    $(this).find('a').addClass('selected_sorting_value');
  }
})


/* ===== Gift Cards variant select ===== */

$('.gift-card-button').click(function(){
  $(this).siblings().removeClass('variant-selected');
  $(this).addClass('variant-selected');
  $('#product-form__item--btn').removeAttr('disabled');
})

/* ====== lazy Loading ====== */

// const images = document.querySelectorAll('[data-src]');

// function preloadImage(img){
//     const src = img.getAttribute("data-src");
//     // if(!src) {
//     //     return;
//     // }
//     img.src = src;
// }

// const imgOptions = {
//     threshold: 0,
//     rootMargin: "0px 0px 0px 0px"
// };

// const imgObserver = new IntersectionObserver((entries, imgObserver)=> {
//     entries.forEach(entry => {
//         if(!entry.isIntersecting) {
//             return;
//         } else {
//             preloadImage(entry.target);
//             imgObserver.unobserve(entry.target);
//         }
//     })
// }, imgOptions);

// images.forEach(image => {
//   imgObserver.observe(image);
// });


// ***** Tooltip ***** //

let tip = tippy('[data-tippy-content]', { theme: "default", interactive: true });


document.addEventListener('lazybeforeunveil', function(e){
  var bg = e.target.getAttribute('data-bg');
  if(bg){
      e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});



// PageFly scrollable section

$(document).ready(function ($) {
  if($('.select-selected').text().trim() == "Choose Size") {
      $('#product-form__item--btn').attr('disabled', 'true');
    }
  $.fn.StickySidebar = function (options) {
      var defaults = {
          'containerSelector': '',
          'additionalMarginTop': 0,
          'additionalMarginBottom': 0,
          'updateSidebarHeight': true,
          'minWidth': 0,
          'disableOnResponsiveLayouts': true,
          'sidebarBehavior': 'modern'
      };
      options = $.extend(defaults, options);

      // Validate options
      options.additionalMarginTop = parseInt(options.additionalMarginTop) || 0;
      options.additionalMarginBottom = parseInt(options.additionalMarginBottom) || 0;

      tryInitOrHookIntoEvents(options, this);

      // Try doing init, otherwise hook into window.resize and document.scroll and try again then.
      function tryInitOrHookIntoEvents(options, $that) {
          var success = tryInit(options, $that);

          if (!success) {

              $(document).scroll(function (options, $that) {
                  return function (evt) {
                      var success = tryInit(options, $that);

                      if (success) {
                          $(this).unbind(evt);
                      }
                  };
              }(options, $that));
              $(window).resize(function (options, $that) {
                  return function (evt) {
                      var success = tryInit(options, $that);

                      if (success) {
                          $(this).unbind(evt);
                      }
                  };
              }(options, $that))
          }
      }

      // Try doing init if proper conditions are met.
      function tryInit(options, $that) {
          if (options.initialized === true) {
              return true;
          }

          if ($('body').width() < options.minWidth) {
              return false;
          }

          init(options, $that);

          return true;
      }

      // Init the sticky sidebar(s).
      function init(options, $that) {
          options.initialized = true;

          // Add CSS
          $('head').append($(
              '<style>.StickySidebar:after {content: ""; display: table; clear: both;}</style>'
              ));

          $that.each(function () {
              var o = {};

              o.sidebar = $(this).parent();

              // Save options
              o.options = options || {};

              // Get container
              o.container = $(o.options.containerSelector);
              if (o.container.length == 0) {
                  o.container = o.sidebar.parent();
              }

              // Create sticky sidebar
              o.sidebar.parents().css('-webkit-transform',
              'none'); // Fix for WebKit bug - https://code.google.com/p/chromium/issues/detail?id=20574
              o.sidebar.css({
                  'position': 'relative',
                  'overflow': 'visible',
                  // The "box-sizing" must be set to "content-box" because we set a fixed height to this element when the sticky sidebar has a fixed position.
                  '-webkit-box-sizing': 'border-box',
                  '-moz-box-sizing': 'border-box',
                  'box-sizing': 'border-box'
              });

              // Get the sticky sidebar element. If none has been found, then create one.
              o.stickySidebar = o.sidebar.find('.StickySidebar');
              if (o.stickySidebar.length == 0) {
                  o.sidebar.find('script')
              .remove(); // Remove <script> tags, otherwise they will be run again on the next line.
                  o.stickySidebar = $('<div>').addClass('StickySidebar').append(o.sidebar
                      .children());
                  o.sidebar.append(o.stickySidebar);
              }

              // Get existing top and bottom margins and paddings
              o.marginTop = parseInt(o.sidebar.css('margin-top'));
              o.marginBottom = parseInt(o.sidebar.css('margin-bottom'));
              o.paddingTop = parseInt(o.sidebar.css('padding-top'));
              o.paddingBottom = parseInt(o.sidebar.css('padding-bottom'));

              // Add a temporary padding rule to check for collapsable margins.
              var collapsedTopHeight = o.stickySidebar.offset().top;
              var collapsedBottomHeight = o.stickySidebar.outerHeight();
              o.stickySidebar.css('padding-top', 1);
              o.stickySidebar.css('padding-bottom', 1);
              collapsedTopHeight -= o.stickySidebar.offset().top;
              collapsedBottomHeight = o.stickySidebar.outerHeight() - collapsedBottomHeight -
                  collapsedTopHeight;
              if (collapsedTopHeight == 0) {
                  o.stickySidebar.css('padding-top', 0);
                  o.stickySidebarPaddingTop = 0;
              } else {
                  o.stickySidebarPaddingTop = 1;
              }

              if (collapsedBottomHeight == 0) {
                  o.stickySidebar.css('padding-bottom', 0);
                  o.stickySidebarPaddingBottom = 0;
              } else {
                  o.stickySidebarPaddingBottom = 1;
              }

              // We use this to know whether the user is scrolling up or down.
              o.previousScrollTop = null;

              // Scroll top (value) when the sidebar has fixed position.
              o.fixedScrollTop = 0;

              // Set sidebar to default values.
              resetSidebar();

              o.onScroll = function (o) {
                  // Stop if the sidebar isn't visible.
                  if (!o.stickySidebar.is(":visible")) {
                      return;
                  }

                  // Stop if the window is too small.
                  if ($('body').width() < o.options.minWidth) {
                      resetSidebar();
                      return;
                  }

                  // Stop if the sidebar width is larger than the container width (e.g. the theme is responsive and the sidebar is now below the content)
                  if (o.options.disableOnResponsiveLayouts) {
                      var sidebarWidth = o.sidebar.outerWidth(o.sidebar.css('float') ==
                          'none');

                      if (sidebarWidth + 50 > o.container.width()) {
                          resetSidebar();
                          return;
                      }
                  }

                  var scrollTop = $(document).scrollTop();
                  var position = 'static';

                  // If the user has scrolled down enough for the sidebar to be clipped at the top, then we can consider changing its position.
                  if (scrollTop >= o.container.offset().top + (o.paddingTop + o
                          .marginTop - o.options.additionalMarginTop)) {
                      // The top and bottom offsets, used in various calculations.
                      var offsetTop = o.paddingTop + o.marginTop + options
                          .additionalMarginTop;
                      var offsetBottom = o.paddingBottom + o.marginBottom + options
                          .additionalMarginBottom;

                      // All top and bottom positions are relative to the window, not to the parent elemnts.
                      var containerTop = o.container.offset().top;
                      var containerBottom = o.container.offset().top + getClearedHeight(o
                          .container);

                      // The top and bottom offsets relative to the window screen top (zero) and bottom (window height).
                      var windowOffsetTop = 0 + options.additionalMarginTop;
                      var windowOffsetBottom;

                      var sidebarSmallerThanWindow = (o.stickySidebar.outerHeight() +
                          offsetTop + offsetBottom) < $(window).height();
                      if (sidebarSmallerThanWindow) {
                          windowOffsetBottom = windowOffsetTop + o.stickySidebar
                              .outerHeight();
                      } else {
                          windowOffsetBottom = $(window).height() - o.marginBottom - o
                              .paddingBottom - options.additionalMarginBottom;
                      }

                      var staticLimitTop = containerTop - scrollTop + o.paddingTop + o
                          .marginTop;
                      var staticLimitBottom = containerBottom - scrollTop - o
                          .paddingBottom - o.marginBottom;

                      var top = o.stickySidebar.offset().top - scrollTop;
                      var scrollTopDiff = o.previousScrollTop - scrollTop;

                      // If the sidebar position is fixed, then it won't move up or down by itself. So, we manually adjust the top coordinate.
                      if (o.stickySidebar.css('position') == 'fixed') {
                          if (o.options.sidebarBehavior == 'modern') {
                              top += scrollTopDiff;
                          }
                      }

                      if (o.options.sidebarBehavior == 'stick-to-top') {
                          top = options.additionalMarginTop;
                      }

                      if (o.options.sidebarBehavior == 'stick-to-bottom') {
                          top = windowOffsetBottom - o.stickySidebar.outerHeight();
                      }

                      if (scrollTopDiff > 0) { // If the user is scrolling up.
                          top = Math.min(top, windowOffsetTop);
                      } else { // If the user is scrolling down.
                          top = Math.max(top, windowOffsetBottom - o.stickySidebar
                              .outerHeight());
                      }

                      top = Math.max(top, staticLimitTop);

                      top = Math.min(top, staticLimitBottom - o.stickySidebar
                      .outerHeight());

                      // If the sidebar is the same height as the container, we won't use fixed positioning.
                      var sidebarSameHeightAsContainer = o.container.height() == o
                          .stickySidebar.outerHeight();

                      if (!sidebarSameHeightAsContainer && top == windowOffsetTop) {
                          position = 'fixed';
                      } else if (!sidebarSameHeightAsContainer && top ==
                          windowOffsetBottom - o.stickySidebar.outerHeight()) {
                          position = 'fixed';
                      } else if (scrollTop + top - o.sidebar.offset().top - o
                          .paddingTop <= options.additionalMarginTop) {
                          // Stuck to the top of the page. No special behavior.
                          position = 'static';
                      } else {
                          // Stuck to the bottom of the page.
                          position = 'absolute';
                      }
                  }

                  /*
                   * Performance notice: It's OK to set these CSS values at each resize/scroll, even if they don't change.
                   * It's way slower to first check if the values have changed.
                   */
                  if (position == 'fixed') {
                      o.stickySidebar.css({
                          'position': 'fixed',
                          'width': o.sidebar.width(),
                          'top': top,
                          'left': o.sidebar.offset().left + parseInt(o.sidebar
                              .css('padding-left'))
                      });
                  } else if (position == 'absolute') {
                      var css = {};

                      if (o.stickySidebar.css('position') != 'absolute') {
                          css.position = 'absolute';
                          css.top = scrollTop + top - o.sidebar.offset().top - o
                              .stickySidebarPaddingTop - o.stickySidebarPaddingBottom;
                      }

                      css.width = o.sidebar.width();
                      css.left = '';

                      o.stickySidebar.css(css);
                  } else if (position == 'static') {
                      resetSidebar();
                  }

                  if (position != 'static') {
                      if (o.options.updateSidebarHeight == true) {
                          o.sidebar.css({
                              'min-height': o.stickySidebar.outerHeight() + o
                                  .stickySidebar.offset().top - o.sidebar.offset()
                                  .top + o.paddingBottom
                          });
                      }
                  }

                  o.previousScrollTop = scrollTop;
              };

              // Initialize the sidebar's position.
              o.onScroll(o);

              // Recalculate the sidebar's position on every scroll and resize.
              $(document).scroll(function (o) {
                  return function () {
                      o.onScroll(o);
                  };
              }(o));
              $(window).resize(function (o) {
                  return function () {
                      o.stickySidebar.css({
                          'position': 'static'
                      });
                      o.onScroll(o);
                  };
              }(o));

              // Reset the sidebar to its default state
              function resetSidebar() {
                  o.fixedScrollTop = 0;
                  o.sidebar.css({
                      'min-height': '1px'
                  });
                  o.stickySidebar.css({
                      'position': 'static',
                      'width': ''
                  });
              }

              // Get the height of a div as if its floated children were cleared. Note that this function fails if the floats are more than one level deep.
              function getClearedHeight(e) {
                  var height = e.height();

                  e.children().each(function () {
                      height = Math.max(height, $(this).height());
                  });

                  return height;
              }
          });
      }
  }
  enquire.register("screen and (min-width:1024px)", function () {
      $('.__pf .fixed-section .sticky').StickySidebar({
          additionalMarginTop: 157,
      });
  })
});

// PageFly scrollable section end 